// TODO: (important) Finalize this file and remove eslint-disable after approval has been confirmed. Extract any remaining text from the file and add it to the appropriate i18n file or backend (?).
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import ContentHeader from 'components/ContentHeader';
import ContestCard from 'components/ContestCard';
import RewardMenu from 'components/RewardMenu/RewardMenu';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import Badge from 'views/BadgeView/IncentiveBadge';

import { baseAppId, storageKeys } from 'settings';

const trackShare = () => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(
        appId,
        email,
        'collateral',
        'rewards',
        `${window.location.href}/main/rewards`,
        'rewards'
      ).then(() => {});
    });
  });
};

/**
 * `RewardsView`
 *
 * @returns {JSX.Element}
 */
const RewardsView = () => {
  const [email, setEmail] = useState('');
  const [contests, setContests] = useState([]);
  const [destinationName, setDestinationName] = useState('');

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  useEffect(() => {
    const fetchData = async () => {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        setDestinationName(appInfo.appName);
      }
    };
    fetchData();
  }, []);
  // If ?mobile=true is in the URL, load accesstoken and set email based on URL params

  useEffect(() => {
    if (contests.length === 0) {
      StorageHandler.load(storageKeys.lang).then(async (lang) => {
        const result = await APIHandler.getContests(baseAppId, {
          currentDate: new Date().toISOString(),
          marketFilter: [{ id: lang.code.toUpperCase() }],
        });

        if (Array.isArray(result) && result.length > 0) {
          const token = await StorageHandler.load(storageKeys.accessToken);

          const data = await Promise.all(
            result.map(async (contest) => {
              const rewards = await APIHandler.getRewards(
                baseAppId,
                token,
                contest.start_date,
                contest.end_date
              );

              return {
                ...contest,
                entriesCount: Array.isArray(rewards.response)
                  ? rewards.response.length
                  : 0,
              };
            })
          );

          setContests(data);
        }
      });
    }
  }, [contests, setContests]);

  // Track share event
  useEffect(() => {
    trackShare();
  }, []);

  useEffect(() => {
    document.body.classList.remove('no-scroll');
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        setEmail((prev) => (res.email !== prev ? res.email : prev));
      }
    });
    if (mobile) {
      // Save token and email from URL params
      const token = params.get('token');

      // If there is no token in the url, check the validity of the token currently stored.
      if (!token) {
        // Get token expiration date
        let accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
          accessToken = JSON.parse(accessToken);
          const expiration = accessToken.expires;
          if (expiration) {
            // Check if token is expired
            const now = new Date();
            const expirationDate = new Date(expiration);
            if (now >= expirationDate) {
              // Token is expired
              this.setState({ loggedIn: false });
              // Remove token from storage
              StorageHandler.remove(storageKeys.accessToken);
              StorageHandler.remove(storageKeys.user);
            }
          }
        }

        return;
      }

      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      const now = new Date();
      const expires = new Date(now.getTime() + thirtyDaysInMilliseconds);

      const user = {
        email: params.get('email'),
        expires: expires.getTime(),
      };

      StorageHandler.save(storageKeys.user, user);

      if (token) {
        // Expecting to have a token
        StorageHandler.save(storageKeys.accessToken, token);
      }

      setEmail(params.get('email') || '');
    }
  }, [email, setEmail, mobile, params]);

  return (
    <div className="contentContainer rewardsView">
      <RewardMenu />

      <div className="bodyRewards">
        <div className="holder">
          <ContentHeader
            header={i18n.translate('rewards.title')}
            subtitle={i18n.translate('rewards.subheader')}
          />
          <hr />

          <div id="current_contest">
            <h3>{i18n.translate('rewards.home.currentContest')}</h3>
            <h4>{i18n.translate('rewards.home.contestHeader')}</h4>

            <div className="current_contest__content">
              <h6>{i18n.translate('rewards.home.contestPrizes')}</h6>
              <ul>
                <li>
                  <span className="text--bold">
                    {i18n.translate('rewards.home.contestPrize1')}
                  </span>
                  {i18n.translate('rewards.home.contestPrize1Description')}
                </li>
                <li>
                  <span className="text--bold">
                    {i18n.translate('rewards.home.contestPrize2')}
                  </span>
                  {i18n.translate('rewards.home.contestPrize2Description')}
                </li>
              </ul>
              <br />
              <h6>{i18n.translate('rewards.home.contestConditions')}</h6>
              <ul>
                <li>
                  <span className="text--bold">
                    {i18n.translate('rewards.home.contestLodging')}
                  </span>
                  {i18n.translate('rewards.home.contestCondition1')}
                </li>
                <li>
                  <span className="text--bold">
                    {i18n.translate('rewards.home.contestGroundServices')}
                  </span>
                  {i18n.translate('rewards.home.contestCondition2')}
                </li>
                <li>
                  <span className="text--bold">
                    {i18n.translate('rewards.home.contestCarRental')}
                  </span>
                  {i18n.translate('rewards.home.contestCondition3')}
                </li>
              </ul>
            </div>
            <p className="text--bold">
              {i18n.translate('rewards.home.contestStartEarning')}
              <Link to="/main/rewards/form" className="linkBookings text--bold">
                {i18n.translate('rewards.home.contestEnterBookings')}
              </Link>
              {i18n.translate('rewards.home.contestNow')}
            </p>

            <p>
              {i18n.translate('rewards.home.contestSeeOther')}
              <Link to="/main/rewards/terms" className="linkTerms">
                {i18n.translate('rewards.home.contestTerms')}
              </Link>
              .
            </p>

            <br />
          </div>
          <hr />

          <Link to="/main/rewards/achievements" className="linkRewards">
            <ContentHeader
              icon={['fas', 'bars']}
              header={i18n.translate('rewards.home.trainingAchievements')}
              subtitle={i18n.translate('rewards.home.trainingAchievementsText')}
              layout="row"
            />
          </Link>

          <hr />

          <Link to="/main/rewards/dashboard" className="linkRewards">
            <ContentHeader
              icon={['far', 'badge']}
              header={i18n.translate('rewards.home.bookingContests')}
              subtitle={i18n.translate('rewards.home.bookingContestsText')}
              layout="row"
            />
          </Link>

          <hr />

          <Link to="/main/rewards/form" className="linkRewards">
            <ContentHeader
              icon="upload"
              header={i18n.translate('rewards.home.submitBooking')}
              subtitle={i18n.translate('rewards.home.submitBookingText')}
              layout="row"
            />
          </Link>

          <hr />
        </div>
      </div>

      {mobile && (
        <style>
          {
            '\
    .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } '
          }
          {'.thankYouView__wrapper { margin-top: 5rem !important; }'}
        </style>
      )}
    </div>
  );
};

export default RewardsView;
